import axios from "axios";
import { InventoryCurrentValueDto, InventoryOrderListReportDto, InventoryPhysicalCountReportDto, InventoryPurchasesReportDto, InventorySalesSummaryReportDto, InventoryTransactionReportDto, RecommendedInventoryReportDto } from "../models/inventoryReports";
import { responseBody } from "./Requests";


export const inventoryReports = {
    getPurchasesReport: (params: URLSearchParams) =>
        axios
            .get<InventoryPurchasesReportDto[]>(`/InventoryReport/listInventoryPurchasesReport`, { params })
            .then(responseBody),
    getPhysicalCountReport: (params: URLSearchParams) =>
        axios
            .get<InventoryPhysicalCountReportDto[]>(`/InventoryReport/listPhysicalCountReport`, { params })
            .then(responseBody),
    getOrderList: (params: URLSearchParams) =>
        axios
            .get<InventoryOrderListReportDto[]>(`/InventoryReport/listInventoryOrderListReport`, { params })
            .then(responseBody),
    getRecommendedInventory: (params: URLSearchParams) =>
        axios
            .get<RecommendedInventoryReportDto[]>(`/InventoryReport/listRecommendedInventoryReport`, { params })
            .then(responseBody),
    getInventorySalesSummary: (params: URLSearchParams) =>
        axios
            .get<InventorySalesSummaryReportDto[]>(`/InventoryReport/listInventorySalesSummaryReport`, { params })
            .then(responseBody),
    getInventoryTransactions: (params: URLSearchParams) =>
        axios
            .get<InventoryTransactionReportDto[]>(`/InventoryReport/listInventoryTransactionReport`, { params })
            .then(responseBody),
    getInventoryCurrentValues: (params: URLSearchParams) =>
        axios
            .get<InventoryCurrentValueDto[]>(`/InventoryReport/listInventoryCurrentValuesReport`, { params })
            .then(responseBody),
}